/*
 * Stat: a labelled figure for overview grids, with an optional hint, icon, trend and chart.
 *   <Stat label={t('overview:servers')} value={4} hint={…} icon={<HardDrives />} />
 *   <Stat label="AI credits left" value={<span className="figures">1,240</span>} chart={<Sparkline values={…} />} />
 */
import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'
import { Panel } from './Panel'

export function Stat({
  label,
  value,
  hint,
  icon,
  trend,
  chart,
  className,
  bare,
}: {
  label: ReactNode
  value: ReactNode
  hint?: ReactNode
  icon?: ReactNode
  /** a small delta next to the value, e.g. <Badge tone="success">+3</Badge> */
  trend?: ReactNode
  chart?: ReactNode
  className?: string
  /** render without the panel (inside another panel) */
  bare?: boolean
}) {
  const body = (
    <>
      <div className="flex items-center justify-between gap-3">
        <span className="text-13 font-medium text-muted">{label}</span>
        {icon ? <span className="text-subtle [&_svg]:size-[18px]">{icon}</span> : null}
      </div>
      <div className="mt-2 flex flex-wrap items-baseline gap-2">
        <span className="font-display figures text-28 leading-9 font-semibold text-ink-deep">{value}</span>
        {trend}
      </div>
      {hint ? <p className="mt-1 text-13 text-subtle">{hint}</p> : null}
      {chart ? <div className="mt-3">{chart}</div> : null}
    </>
  )
  if (bare) return <div className={className}>{body}</div>
  return (
    <Panel padded className={cn('flex flex-col', className)}>
      {body}
    </Panel>
  )
}
